<template>
<div>

    <section class="common">

        <div style="text-align: right; padding-bottom: 4rem;" v-if="form && brands.length > 0">
            <button class="" v-on:click="clickBrandSearchHistory()">
                <label for="like-btn1" class="btn_common _like">
                    <div class="md_svg-icon">
                        <SvgIconAdd />
                    </div>
                    <span>検索条件を保存する</span>
                </label>
            </button>
        </div>

        <div v-if="brands.length == 0" style="text-align: center;" >
            <p style="padding-bottom: 4rem;">検索結果がありませんでした。</p>
            <button class="" style=" padding-bottom: 4rem; margin: 0 auto;" v-on:click="backList()">
                <label for="like-btn1" class="btn_common _like">
                    <div class="md_svg-icon">
                        <SvgIconAdd />
                    </div>
                    <span>一覧に戻る</span>
                </label>
            </button>
        </div>

        <div class="section-inner">

        <!-- card_brand-list -->
            <div class="card_brand-list">

            <!-- row -->
                <div class="row js-scroll-target" v-for="(box) in brandList" v-bind:key="box.id">

                <!-- card -->
                    <div v-for="(brand) in box" v-bind:key="brand.id" class="card js-tilt">
                        <a v-on:click="show_brand_detail(brand.id)" class="link-ovl"></a>
                        <div class="hover-element"></div>
                        <!-- ロゴの時には、<div class="img-wrap _logo js-scroll-target"> とする -->
                        <div class="img-wrap js-scroll-target" >
                            <img v-bind:src=" $store.state.const.AWS_S3_URL_HOST + brand.logo " alt="">
                        </div>
                        <div class="detail-wrap">
                            <h3>{{brand.name}}</h3>
                        </div>
                        <div class="btn_link-wrap">
                            <button type="button" class="btn_link" v-on:click="show_brand_detail(brand.id)"><span>MORE INFO</span></button>
                            <div class="bg-element"></div>
                        </div>
                    </div>

                </div><!-- /.row -->
            </div><!-- /.card_brand-list -->
        </div><!-- /.section-inner -->
    </section>
    <AlertModal
        v-if="showAlertModal"
        @close="closeAlertModal"
        :title="alert_modal_title"
        :message="alert_modal_message"
        :mode="alert_modal_mode"
    />
</div>
</template>

<script>
    import EndUserLayout from '@/Layouts/EndUserLayout'
    import VanillaTilt from 'vanilla-tilt';
    import AlertModal from '@/components/EndUser/ComponentList/AlertModal'
    import { Link } from '@inertiajs/inertia-vue3'
    import commonMixins from '@/common/utility.js'

    //Svg
    import SvgIconAdd from '@/components/EndUser/svg/SvgIconAdd'

    export default {
        mixins: [commonMixins],
        components: {
            "AlertModal": AlertModal,
            "Link": Link,
            //Svg
            SvgIconAdd,
        },
        props:{
            user: Array,
            brands: Array,
            brandList: Array,
            // 検索条件
            form: Array,
            search_history: Array,
            // マスタデータ
            sales_recruitments: Object,
            orders: Object,
            sales_styles: Object,
            pay_rules: Object,
            area_prefectures: Object,
            area_cities: Object,
            second_categories: Object,
            third_categories: Object,
        },
        data() {
            return {
                local_storage_form: [],
                showAlertModal: false,
                alert_modal_title: '',
                alert_modal_message: '',
                alert_modal_mode: '',
            }
        },
        layout: EndUserLayout,
        created() {
            window.addEventListener('pageshow',()=>{
                if(window.performance.navigation.type==2) {
                    //ScrollTarget --------------------
                    this.jsScrollTargets();
                    //CursorFollower --------------------
                    this.cursorFollower();
                }
            });
        },
        mounted() {
            if (window.innerWidth <= 1024) {
                //vanilla-tilt.js --------------------
                VanillaTilt.init(document.querySelectorAll(".js-tilt"), {
                    reverse: true,
                    max: 20,
                    speed: 1000,
                    gyroscope: true,
                });
            } else {
                //vanilla-tilt.js --------------------
                VanillaTilt.init(document.querySelectorAll(".js-tilt"), {
                    reverse: true,
                    max: 8,
                    speed: 1000,
                    gyroscope: true,
                });
            }
            this.$store.state.search.set.user = this.user;
            this.$store.state.search.set.form = this.form;

            // ログインの有無
            if (this.$store.state.search.set.user) {
                if (this.search_history) {
                    this.$store.state.search.set.search_history = this.search_history;
                }
            } else {
                var forms = JSON.parse(localStorage.getItem('forms')) || [];
                this.$store.state.search.set.search_history = forms;
            }
        },
        methods: {
            clickBrandSearchHistory: function() {
                // ブランドロゴのパスを取得 (3つまで)
                var brand_path = [];
                for(var i in this.brands) {
                    var brand = this.brands[i];
                    brand_path.push(brand.logo);
                    if (i > 1) {
                        break;
                    }
                }

                var brand_history = this.dataOrganize(this.form);

                this.$store.state.search.set.form.brand_path = brand_path;
                this.$store.state.search.set.form.brand_history = brand_history;
                if (location.pathname == '/showroom-list') {
                    this.$store.state.search.set.form.type = 2;
                } else {
                    this.$store.state.search.set.form.type = 1;
                }

                // ログインユーザー情報が取れていたらDBに保存、ログインユーザー情報がなければローカルストレージに保存
                if (this.$store.state.search.set.user) {

                    this.$store.state.search.set.search_history.push(this.$store.state.search.set.form);

                    axios.post('/brand_search_history',{
                        form: this.$store.state.search.set.search_history
                    }).then(()=>{
                        this.openAlertModal('success', '保存完了', '検索条件を保存しました。'); // 確認済み
                        location.reload();
                    })

                } else { // 非ログイン
                    var forms = JSON.parse(localStorage.getItem('forms')) || [];
                    var form = this.$store.state.search.set.form
                    forms.push(form);

                    localStorage.setItem('forms', JSON.stringify(forms));
                    this.$store.state.search.set.search_history = forms;
                    this.openAlertModal('success', '保存完了', '検索条件を保存しました。'); // 確認済み
                }
            },
            dataOrganize: function(history_form) {
                var return_brand_history = [];

                //価値評価
                if (history_form.price_zone) {
                    return_brand_history.push(history_form.price_zone.name);
                }

                //カテゴリ
                if (history_form.categoriyLv3 && 0 < history_form.categoriyLv3.length) {
                    return_brand_history.push('Apparel');
                }

                if (history_form.categoriyLv2) {
                    var life_style = false;
                    var food = false;
                    var beauty_health = false;
                    for(var i in history_form.categoriyLv2) {
                        var categoriyLv2 = history_form.categoriyLv2[i];
                        if (categoriyLv2.first_category_id == 2) {
                            life_style = true;
                        }
                        if (categoriyLv2.first_category_id == 3) {
                            food = true;
                        }
                        if (categoriyLv2.first_category_id == 4) {
                            beauty_health = true;
                        }
                    }

                    if (life_style) {
                        return_brand_history.push('Life Style');
                    }
                    if (food) {
                        return_brand_history.push('Food');
                    }
                    if (beauty_health) {
                        return_brand_history.push('Beauty＆Health');
                    }
                }

                // セールス募集B
                if (history_form.sales_recruitment_b) {
                    for(var i in history_form.sales_recruitment_b) {
                        var sales_recruitment_b = history_form.sales_recruitment_b[i];
                        var result = this.sales_recruitments.filter((f_sales_recruitment) => {
                            return (f_sales_recruitment.id == sales_recruitment_b);
                        });
                        return_brand_history.push(result[0].name);
                    }
                }

                // セールス募集C
                // if (history_form.sales_recruitment_c) {
                //     for(var i in history_form.sales_recruitment_c) {
                //         var sales_recruitment_c = history_form.sales_recruitment_c[i];
                //         return_brand_history.push(sales_recruitment_c.name);
                //     }
                // }

                // 受注生産
                if (history_form.order) {
                    for(var i in history_form.order) {
                        var order = history_form.order[i];
                        var result = this.orders.filter((f_order) => {
                            return (f_order.id == order);
                        });
                        return_brand_history.push(result[0].name);
                    }
                }

                // セールススタイル
                if (history_form.sales_style) {
                    for(var i in history_form.sales_style) {
                        var sales_style = history_form.sales_style[i];
                        var result = this.sales_styles.filter((f_sales_style) => {
                            return (f_sales_style.id == sales_style);
                        });
                        return_brand_history.push(result[0].name);
                    }
                }

                // お支払い方法
                if (history_form.pay_rule) {
                    for(var i in history_form.pay_rule) {
                        var pay_rule = history_form.pay_rule[i];
                        var result = this.pay_rules.filter((f_pay_rule) => {
                            return (f_pay_rule.id == pay_rule);
                        });
                        return_brand_history.push(result[0].name);
                    }
                }

                // エリア
                if (history_form.areaLv3) {
                    for(var i in history_form.areaLv3) {
                        var areaLv3 = history_form.areaLv3[i];
                        var result = this.area_cities.filter((f_area_citie) => {
                            return (f_area_citie.id == areaLv3);
                        });
                        return_brand_history.push(result[0].name);
                    }
                }

                //対象店舗
                if (history_form.net_shop) {
                    return_brand_history.push(history_form.net_shop.name);
                }

                //ターゲットmax
                if (history_form.target_max) {
                    return_brand_history.push(history_form.target_max + '円以下');
                }

                //ターゲットmin
                if (history_form.target_min) {
                    return_brand_history.push(history_form.target_min + '円以上');
                }

                //プライスmax
                if (history_form.price_max) {
                    return_brand_history.push(history_form.price_max + '円以下');
                }

                //プライスmin
                if (history_form.price_min) {
                    return_brand_history.push(history_form.price_min + '円以上');
                }

                //ハッシュタグ
                if (history_form.hashtags) {
                    for(var i in history_form.hashtags) {
                        var hashtags = history_form.hashtags[i];
                        return_brand_history.push(hashtags);
                    }
                }

                //フリーワード
                if (history_form.freeText) {
                    return_brand_history.push(history_form.freeText);
                }

                return return_brand_history;

            },
            backList: function () {
                if (location.pathname == '/showroom-list') {
                    var url = '/showroom-list';
                } else {
                    var url = '/brand-list';
                }
                location.href= url;
            },
            openAlertModal(mode, title, message) {
                this.alert_modal_mode = mode;
                this.alert_modal_title = title;
                this.alert_modal_message = message;
                this.showAlertModal = true;
            },
            closeAlertModal() {
                this.showAlertModal = false;
                this.alert_modal_mode = '';
                this.alert_modal_title = '';
                this.alert_modal_message = '';
            },
            show_brand_detail: function (brand_id) {
                if (location.pathname == '/showroom-list') {
                    let url = 'showroom_detail';
                    location.href= route('showroom_detail', brand_id);
                } else {
                    location.href= route('brand_detail', brand_id);
                }
            },
        },
    };
</script>
